import http from './http';
import api from '../config/a20-pregled-kumulativa-config.json';

export const pregledKumulativaService = {
    get: (operativniBroj) =>
        http.post(`${api.getKumulativi}`, { operativniBroj })
};
